import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet } from "@tanstack/react-router"

import { RecordAttention } from "@/components/common/record-attention"
import { AppShell } from "@/components/layout/app-shell"
import { useAttentionSection } from "@/hooks/use-attention-section"
import { IndividualProperties } from "@/features/individuals/components/individual-properties"
import { IndividualSidebar } from "@/features/individuals/components/individual-sidebar"
import { individualQueries } from "@/queries/individuals"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/individuals/$individualId"
)({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(
      individualQueries.detail(params.individualId)
    ),
  component: IndividualWorkspaceLayout,
})

function IndividualWorkspaceLayout() {
  const { individualId } = Route.useParams()
  const section = useAttentionSection()
  const { data: individual } = useSuspenseQuery(
    individualQueries.detail(individualId)
  )

  return (
    <>
      <AppShell
        sidebar={<IndividualSidebar individual={individual} />}
        aside={<IndividualProperties individual={individual} />}
        attention={
          section ? (
            <RecordAttention
              subject="individual"
              id={individualId}
              section={section}
            />
          ) : null
        }
      >
        <Outlet />
      </AppShell>
    </>
  )
}
